import { Flex, InputRightElement, Stack } from '@chakra-ui/react';

import IconButton from 'components/_core/IconButton';
import SearchBar from 'components/SearchBar';

import { useFilters } from '../../pages/hooks/useFilters';
import StatusDropdown from './components/StatusDropdown';
import locales from './locales';

interface Status {
  value: string;
  label: string;
}

interface FiltersProps {
  statuses?: Status[];
  onStatusChange?: (statuses: string[]) => void;
  placeholder?: string;
}

const Filters = ({
  onStatusChange,
  placeholder,
  statuses = [],
}: FiltersProps) => {
  const { filters, updateFilters } = useFilters();

  const hasStatuses = statuses.length > 0 && onStatusChange;

  return (
    <Stack marginBottom="space-24" spacing="space-24">
      <Flex gap="space-16">
        <SearchBar
          flexGrow={1}
          onChange={(q) => updateFilters({ ...filters, q })}
          placeholder={placeholder}
          value={filters.q}
        >
          {filters.q ? (
            <InputRightElement>
              <IconButton
                aria-label={locales.clear}
                icon="cross"
                onClick={() => updateFilters({ ...filters, q: '' })}
                variant="inline-secondary"
              />
            </InputRightElement>
          ) : null}
        </SearchBar>

        {hasStatuses ? (
          <StatusDropdown
            onStatusChange={onStatusChange}
            options={statuses}
            selectedFilters={filters.statuses ?? []}
          />
        ) : null}
      </Flex>
    </Stack>
  );
};

export default Filters;
